/*eslint complexity: off*/
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import moment from 'moment';

import LocalActivity from '@material-ui/icons/LocalActivity';

import Paper from '~/components/Paper';
import GridItem from '~/components/GridItem';
import InputShow from '~/components/InputShow';
import ModalDelete from '~/components/ModalDelete';
import PaperButtons from '~/components/PaperButtons';
import GridContainer from '~/components/GridContainer';

import Request from '~/providers/Request';
import CouponRecord from '~/records/CouponRecord';
import { AbilityContext } from '~/contexts/Can';
import { historyPropType } from '~/config/routerPropTypes';
import { coupon, createCoupon, editCoupon } from '~/config/routes';

import Context from './context';

const attrName = (attr) => CouponRecord.hummanAttributeName(attr);

function ShowCoupon({ history }) {
  const { id } = history.location.route.getParams();
  const { records, addRecords } = useContext(Context);
  const [record, setRecord] = useState(new CouponRecord());
  const { t } = useTranslation();
  const [loading, setLoading] = useState(!records || !records[id]);
  const [modal, setModal] = useState(false);
  const ability = useContext(AbilityContext);

  useEffect(() => {
    if (records && records[id]) {
      setRecord(record.updateAttributes(records[id]));
    }
    setLoading(true);
    Request.get(`/admin/coupon/${id}`, {})
      .then((response) => {
        console.log(response.data);
        setLoading(false);
        addRecords({ data: [response.data] });
        setRecord(record.updateAttributes(response.data));
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  async function handleDelete() {
    setLoading(true);
    Request.del(`/admin/coupon/${id}`)
      .then(() => {
        toast.success(t('delete-toast-success'));
        history.push(coupon.spec);
      })
      .catch(() => {
        setLoading(false);
        toast.error(t('delete-toast-fail'));
      });
    setModal(false);
  }

  return (
    <Paper
      Icon={LocalActivity}
      iconColor="blue"
      title={t('coupon.defSingular')}
      loading={loading}
      actions={
        <PaperButtons
          id={id}
          setModal={ability.can('delete', 'Coupon') ? setModal : null}
          backRoute={coupon}
          newRoute={ability.can('new', 'Coupon') ? createCoupon : null}
          editRoute={ability.can('edit', 'Coupon') ? editCoupon : null}
        />
      }
    >
      <GridContainer>
        <GridItem xs={12} sm={6}>
          <InputShow 
            label={attrName('name')} 
            value={record.get('name')} />
        </GridItem>
        <GridItem xs={12} sm={6}>
          <InputShow 
            label={attrName('promotion_type')} 
            value={record.get('promotion_type')} />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={6}>
          <InputShow 
            label={attrName('user_limit')} 
            value={record.get('user_limit')}
          />
        </GridItem>
        <GridItem xs={12} sm={6}>
          <InputShow 
            label={attrName('times_used')} 
            value={record.get('times_used') ? record.get('times_used') : '0'}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={6}>
          <InputShow 
            label={attrName('start_date')} 
            value={record.get('start_date') ? moment(record.get('start_date')).format('DD/MM/YYYY HH:mm') : null}
          />
        </GridItem>
        <GridItem xs={12} sm={6}>
          <InputShow 
            label={attrName('expires_at')} 
            value={record.get('expires_at') ? moment(record.get('expires_at')).format('DD/MM/YYYY HH:mm') : null}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={6}>
          <InputShow 
            label={attrName('discount_type')} 
            value={record.get('discount_type') === 1 ? 'Porcentagem' : 'Real'}
          />
        </GridItem>
        <GridItem xs={12} sm={6}>
          <InputShow 
            label={attrName('discount_value')} 
            value={record.get('discount_value')}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={6}>
          <InputShow 
            label={attrName('created_at')} 
            value={record.get('created_at') ? moment(record.get('created_at')).format('DD/MM/YYYY HH:mm:ss') : null}
          />
        </GridItem>
        <GridItem xs={12} sm={6}>
          <InputShow 
            label={attrName('updated_at')} 
            value={record.get('updated_at') ? moment(record.get('updated_at')).format('DD/MM/YYYY HH:mm:ss') : null}
          />
        </GridItem>
      </GridContainer>

      <ModalDelete
        modal={modal}
        onClose={() => {
          setModal(false);
        }}
        name={record.get('name')}
        id={record.get('id')}
        deleteAction={handleDelete}
      />
    </Paper>
  );
}

ShowCoupon.propTypes = {
  history: historyPropType,
};

export default ShowCoupon;
